<template>
  <div class="home">
      <!-- <Header /> -->
      <div class="home-middle">
        <HotProduct />
        <ServiceJump />
      </div>
      
  </div>
</template>

<script>
// import Header from '../../components/Header'
import HotProduct from '../../components/HotProduct'
import ServiceJump from '../../components/ServiceJump'
export default {
    components: {
        // Header,
        HotProduct,
        ServiceJump
    }
}
</script>

<style scoped>
.home {
    /* margin: 0 25px; */
    box-sizing: border-box;
}
.home-middle {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}
</style>